import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { connect } from 'react-redux';
import { Provider } from 'react-redux';
import PageOpsMediaModal from './helpers/PageOpsMediaModal'

import pageBuilderCont from './reducers/Index.js';
import Pagebuilder from './components/Pagebuilder.js';
import PageTools from './components/PageTools.js';
import _ from 'lodash'

window.sppbMySectionsRequestRequered = true;
window.ReactDOM = ReactDOM;

window.warningAtReload = false;

let store = createStore(pageBuilderCont);

window.addEventListener('load', () => {
  let iframe = document.getElementById('sp-pagebuilder-view'),
      parentNode = iframe.parentNode;

  while(parentNode !== null && parentNode.tagName != 'BODY' ){
    parentNode.style.height = '100%';
    parentNode.style.width = '100%';
    parentNode.style.maxWidth = '100%';
    parentNode = parentNode.parentNode;
  }


  iframe.src = iframe.dataset.url;
})

document.getElementById('sp-pagebuilder-view').addEventListener('load', () => {
  if(document.getElementById('sp-pagebuilder-container')){
    document.getElementById('sp-page-builder').removeChild(document.getElementById('sp-pagebuilder-container'));
  }
  ReactDOM.render(
    <Provider store={store}>
      <Pagebuilder />
    </Provider>,
    window.frames['sp-pagebuilder-view'].window.document.getElementById('sp-pagebuilder-container')
  );
})

const render_tools = () => {
  ReactDOM.render(
    <Provider store={store}>
      <PageTools />
    </Provider>,
    document.getElementById('sp-pagebuilder-page-tools')
  );
};
render_tools();

// Page Options Media Manager
const pageOpsModalRender = () => {
  ReactDOM.render(
    <PageOpsMediaModal />,
    document.getElementById('sp-pagebuilder-media-modal')
  );
};

pageOpsModalRender();

var pageOpsMediaUploadButton = document.getElementById('media-upload-button');
pageOpsMediaUploadButton.addEventListener('click',function(event){
  event.preventDefault();
  jQuery('.sp-pagebuilder-media-modal-overlay').show();
},false);

jQuery(document).ready(function($) {
  $('.sp-pagebuilder-browse-media, .sp-pagebuilder-media-loadmore').on('click',function(event) {
    event.preventDefault();
    $(this).addClass('active-action-spinner');
  });

  $(document).on('click', '.sp-pagebuilder-btn-clear-media', function(event) {
		event.preventDefault();
		var $this = $(this);
		$this.siblings('.sp-pagebuilder-media-preview').addClass('sp-pagebuilder-media-no-image').removeAttr('src');
		$this.siblings('input').val('');
	})
});


jQuery(window.frames['sp-pagebuilder-view'].window.document).on('click', 'a', function(e){
  e.preventDefault();
  return false;
})

window.parseUrl = (str) => {
  var query

  var key = [
    'source',
    'scheme',
    'authority',
    'userInfo',
    'user',
    'pass',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'fragment'
  ]

  // For loose we added one optional slash to post-scheme to catch file:/// (should restrict this)
  var parser = new RegExp([
      '(?:([^:\\/?#]+):)?',
      '(?:\\/\\/()(?:(?:()(?:([^:@\\/]*):?([^:@\\/]*))?@)?([^:\\/?#]*)(?::(\\d*))?))?',
      '()',
      '(?:(()(?:(?:[^?#\\/]*\\/)*)()(?:[^?#]*))(?:\\?([^#]*))?(?:#(.*))?)'
    ].join(''));

  var m = parser.exec(str)
  var uri = {}
  var i = 14

  while (i--) {
    if (m[i]) {
      uri[key[i]] = m[i]
    }
  }

  delete uri.source
  return uri
}

// Utility Functions

window.getMarginPadding = ( values, valueType ) => {
  let marginValue;
  if(typeof values !== 'undefined' && _.isObject(values)){
    marginValue = {
      md: '',
      sm: '',
      xs: ''
    };
    if(typeof values.md !== 'undefined' && values.md.trim() != ''){
      marginValue.md = values.md.split(" ").map((item, index) => {
        let pos = ['top', 'right', 'bottom', 'left'];

        if(!_.isEmpty(item.trim())){
          return valueType+'-'+pos[index]+': '+item+';';
        }

      }).join("")
    }

    if(typeof values.sm !== 'undefined' && values.sm.trim() != ''){
      marginValue.sm = values.sm.split(" ").map((item, index) => {
        let pos = ['top', 'right', 'bottom', 'left'];

        if(!_.isEmpty(item.trim())){
          return valueType+'-'+pos[index]+': '+item+';';
        }

      }).join("")
    }

    if(typeof values.xs !== 'undefined' && values.xs.trim() != ''){
      marginValue.xs = values.xs.split(" ").map((item, index) => {
        let pos = ['top', 'right', 'bottom', 'left'];

        if(!_.isEmpty(item.trim())){
          return valueType+'-'+pos[index]+': '+item+';';
        }

      }).join("")
    }

    return marginValue;
  } else if(typeof values === "number") {
    return valueType+': '+values+';';
  } else {
    marginValue = '';
    if(typeof values !== 'undefined' && values.trim() != ''){
      marginValue = values.split(" ").map((item, index) => {
        let pos = ['top', 'right', 'bottom', 'left'];

        if(!_.isEmpty(item.trim())){
          return valueType+'-'+pos[index]+': '+item+';';
        }

      }).join("")
    }

    return marginValue;
  }
}


window.sppbNotify = ( message = '' ) => {
  if(jQuery('.sp-pagebuilder-notifications').length === 0) {
    jQuery('<div class="sp-pagebuilder-notifications"></div>').appendTo('body')
  }
	jQuery('<div class="notify-success"><i class="fa fa-exclamation-triangle"></i> ' + message + '</div>').css({
		opacity: 0,
		'margin-top': -15,
		'margin-bottom': 0
	}).animate({
		opacity: 1,
		'margin-top': 0,
		'margin-bottom': 15
	},200).prependTo('.sp-pagebuilder-notifications');
  
	jQuery('.sp-pagebuilder-notifications').find('>div').each(function() {
		var $this = jQuery(this);
  
		setTimeout(function(){
		  $this.animate({
			opacity: 0,
			'margin-top': -15,
			'margin-bottom': 0
		  }, 200, function() {
			$this.remove();
		  });
		}, 1200);
	});
}


// WEBPACK FOOTER //
// ./src/main.js